import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonContainer, Container, Content, Message } from './styled';
import { ExpandButton, Loader } from 'mol-ui';

const ListLayout = ({
    buttonText,
    children,
    empty,
    emptyMessage,
    loading,
    onButtonClick
}) => {
    
    const { t } = useTranslation();
    
    return (
        <Container>
            <Content>
                {
                    loading
                        ? <Loader active={ true } />
                        : empty
                            ? <Message>
                                { emptyMessage || t('No hay elementos') }
                            </Message>
                            : children
                }
            </Content>
            <ButtonContainer>
                <ExpandButton
                    caption={ buttonText || t('Nuevo elemento') }
                    size={ 120 }
                    width={ 150 }
                    onClick={ onButtonClick }
                />
            </ButtonContainer>
        </Container>
    );
};

ListLayout.propTypes = {
    buttonText: PropTypes.string,
    children: PropTypes.any,
    empty: PropTypes.bool,
    emptyMessage: PropTypes.string,
    loading: PropTypes.bool,
    onButtonClick: PropTypes.func
};

export default ListLayout;
